import LaunchIcon from "@mui/icons-material/Launch";
import React from "react";

export default function LaunchIconLink({ link }) {

    const handleClick = (event) => {
    event.stopPropagation();

    if (link) {
      window.open(link, '_blank', 'noopener,noreferrer');
    }
  };

  return (
    <LaunchIcon
      onClick={handleClick}
      aria-label="open link"
      sx={{
        fontSize: '1rem',
        ml: 0.5,
        verticalAlign: 'middle',
        cursor: link ? 'pointer' : 'default'
      }}
    />
  );
};